import { Form, Formik, FormikErrors } from 'formik';
import { FormPasswordField, FormTextField, SubmitButton, Typography } from 'omakase';
import { Grid } from 'ui';
import { InputAdornment } from '@material-ui/core';
import { getStrength } from '@tock/shared/utils/passwordHelpers';
import { isGoodPassword } from '@tock/shared/utils/FormValidators';

interface Fields {
  email: string;
  password: string;
}

const validate = ({ password }: Fields) => {
  const errors: FormikErrors<Fields> = {};
  if (!isGoodPassword(password)) {
    errors.password = 'Password must be at least 8 characters in length.';
  }
  return errors;
};

interface Props {
  email: string;
  token: string;
  onSubmit(values: Fields): void;
}

const ResetPasswordForm: React.FC<Props> = ({ email, token, onSubmit }) => {
  return (
    <Formik
      initialValues={{ email, token, password: '' }}
      onSubmit={onSubmit}
      validate={validate}
      enableReinitialize
    >
      {({ values, isSubmitting, isValidating, isValid, dirty }) => {
        const strength = getStrength(values.password);
        const postfix = strength.msg;
        return (
          <Form>
            <Grid container spacing={2}>
              <Grid item>
                <Typography color="inherit" component="span" variant="body02">
                  Enter a new password below to securely reset your password.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <FormTextField id="email" name="email" label="Email address" disabled fullWidth />
              </Grid>
              <Grid item xs={12}>
                <FormPasswordField
                  id="password"
                  name="password"
                  label="Password"
                  fullWidth
                  helperText="Passwords must be at least 8 characters. Strong passwords have letters, numbers, and symbols."
                  endAdornment={<InputAdornment position="end">{postfix}</InputAdornment>}
                />
              </Grid>
              <Grid item xs={12}>
                <SubmitButton
                  fullWidth
                  size="large"
                  variant="primary"
                  disabled={isSubmitting || isValidating || !isValid || !dirty}
                >
                  Reset my password
                </SubmitButton>
              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ResetPasswordForm;
